/* global React */
import LinkHOC from '@platform/react/hoc/link'
import MenuItem from '../Item'

const MenuLink = LinkHOC(React.forwardRef(MenuItem))

export default MenuLink
